module.exports = __webpack_public_path__ + "img/blockAB43.242a12e3.svg";